import React, { Component } from "react";
import { StyleSheet, View, Text, TouchableOpacity } from "react-native";

export default function (props) {
  return (
    <View>
      <TouchableOpacity
        style={styles.container}
        onPress={() => props.onChange()}>
        <Text style={{ color: "#3E4672", fontFamily: "Montserrat-Bold" }}>
          {props.titulo}
        </Text>
        <Text style={{ color: "#3E4672", fontFamily: "Montserrat-Regular" }}>
          {props.fecha}
        </Text>
        <Text style={{ color: "#3E4672", fontFamily: "Montserrat-Regular" }}>
          {props.usuario}
        </Text>
        <Text style={{ color: "#3E4672", fontFamily: "Montserrat-Bold" }}>
          {props.numAdultos} Adulto {props.numNinos} Niños
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => props.onPress(props.id, props.titulo, props.fecha)}
        style={{
          elevation: 2,
          zIndex: 999,
          backgroundColor: "#3E4672",
          paddingTop: 10,
          paddingBottom: 10,
          width: 150,
          alignSelf: "center",
          top: -50,
          right: -100,
          borderRadius: 20,
        }}>
        <Text
          style={{
            color: "white",
            textAlign: "center",
            fontWeight: "bold",
            fontFamily: "Nunito-Bold",
          }}>
          Cancelar cita
        </Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  button: {},
  label: {
    fontFamily: "Nunito-Regular",
    fontSize: 17,
    textAlign: "center",
    lineHeight: 38,
    color: "#3E4672",
  },
  container: {
    padding: 10,
    maxWidth: "90%",
    width: 300,
    minHeight: 100,
    alignSelf: "center",
    backgroundColor: "white",
    borderRadius: 15,
    marginBottom: 20,
    marginTop: 20,
    shadowColor: "#CACACA",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
});
